module.exports = __webpack_public_path__ + "img/kogermann_lab.d8a1f5b3.png";